module.exports = __webpack_public_path__ + "img/transfer_img.eba27623.png";